// extracted by mini-css-extract-plugin
export default {"nftComment":"rGaFJwbvaHjgj9HjwC2T","nftCommentMoreButton":"MOHH3FglJIT0FJrgsGFq"};